export const COLORS = {
    bg:          '#F4F6F3',
    card:        '#FFFFFF',
    border:      '#D6E0D0',
    g1:          '#3B6D11',
    g2:          '#639922',
    g3:          '#97C459',
    tSec:        '#2D5016',
    tDim:        '#4A6B38',
    kpiBg:       '#F0F5EB',
    amber:       '#7A4A08',
    amberBg:     '#FAEEDA',
    red:         '#7A1F1F',
    redBg:       '#FCEAEA',
    bannerBg:    '#1E5139',
    bannerText:  '#C0DD97',
};

